
export enum AdvancedAnalysisVisibilityFieldTypeValues {
    Defined = 'defined',
    Truthy = 'truthy',
    Falsey = 'falsey',
    Contains = "contains",
    DoesNotContain = "does_not_contain"
}

// Provide configurable field visibility
// Currently if any visible_config matches the field is visible
// Optionally configure visible_value to specify any defined value, or truthy/falsey value 
// should be considered a match for visibility. This overrides any defined visible_prop_values
export interface IAdvancedAnalysisVisibilityFieldTypeArgs {
    visible_configs: Array<{
        visible_prop_path: string,
        visible_prop_value: any,
        visible_value?: AdvancedAnalysisVisibilityFieldTypeValues,
        visible_parent?: string
    }>
}

// See AdvancedAnalysissUiService.transformValueForValueMappedField or supported field_types
// Note that mapped fields may references fields anwhere in the configuration
// however they may only be defined on configurationLevel 1
export interface IAdvancedAnaylsisValueMappingFieldTypeArgs {

    value_map: {
        // straight mapping if only src_prop_path defind
        src_prop_path: string,
        preserve_existing: boolean,
        // conditional mapping of expected values 
        // optional dynamic value_prop_path to use based on src_prop_value 'value' of root src_prop_path
        src_value_conditions: Array<{ value_prop_path?: string, src_prop_value: any }>
    }

}
